<script>
import pdf from './pdf-viewer'

export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'pdf',
  inheritAttrs: false,
  functional: true,
  props: {
    path: {
      type: String,
      required: true
    },
    isInPropEditor: {
      type: Boolean,
      default: false
    },
    isFullscreen: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: '',
      input: 'text',
      label: 'name',
      condition: (values, path) => path.startsWith('/assets/')
    },
    // eslint-disable-next-line
    _headlineClickBehaviour: {
      input: 'heading',
      label: 'click behaviour',
      condition: (values, path) => !path.startsWith('/assets/')
    },
    clickBehaviour: {
      type: String,
      default: 'fullscreen',
      validator (value) {
        return ['fullscreen', 'none'].includes(value)
      },
      input: 'radio',
      choices: {
        fullscreen: 'fullscreen',
        none: 'ignore'
      },
      condition: (values, path) => !path.startsWith('/assets/')
    },
    // eslint-disable-next-line
    _headlinePdfSettings: {
      input: 'heading',
      label: 'PDF settings',
      condition: (values, path) => !path.startsWith('/assets/')
    },
    expandPages: {
      type: Boolean,
      default: false,
      input: 'checkbox',
      label: 'expand pages',
      condition: (values, path) => !path.startsWith('/assets/')
    },
    // eslint-disable-next-line
    _headlineSelectPages: {
      input: 'heading',
      label: 'select pages',
      condition: (values, path) => !path.startsWith('/assets/')
    },
    pageFrom: {
      type: Number,
      default: 0,
      label: 'page from',
      input: 'number',
      min: 0,
      condition: (values, path) => !path.startsWith('/assets/')
    },
    pageTo: {
      type: Number,
      default: 0,
      label: 'page to',
      input: 'number',
      min: 0,
      condition: (values, path) => !path.startsWith('/assets/')
    },
    // eslint-disable-next-line
    _headlineCaption: {
      input: 'heading',
      label: 'caption',
      condition: (values, path) => !path.startsWith('/assets/')
    },
    caption: {
      type: String,
      default: '',
      input: 'text',
      condition: (values, path) => !path.startsWith('/assets/')
    }
  },
  render (createElement, context) {
    // get number of pages from page cache
    let numPages
    if (context.parent.cache && context.parent.cache[context.props.src] && context.parent.cache[context.props.src].numPages) {
      numPages = context.parent.cache[context.props.src].numPages
    } else {
      numPages = 1
    }
    function createPage (page) {
      return createElement(
        pdf,
        {
          ...context.data,
          key: context.props.path + '-' + page,
          props: {
            path: context.props.path,
            src: context.props.src,
            ratio: context.parent.cache &&
                   context.parent.cache[context.props.src] &&
                   context.parent.cache[context.props.src].pages &&
                   context.parent.cache[context.props.src].pages[page] &&
                   context.parent.cache[context.props.src].pages[page].ratio,
            name: context.props.name,
            page,
            scale: context.parent.$store.getters.path.startsWith('/assets/') || context.props.isFullscreen ? 'height' : 'width',
            clickBehaviour: context.props.clickBehaviour,
            isFullscreen: context.props.isFullscreen,
            isInPropEditor: context.props.isInPropEditor,
            caption: context.props.caption
          }
        },
        context.children
      )
    }
    if (!context.props.expandPages && !context.props.isFullscreen) {
      return createPage(1)
    } else {
      const pages = []
      // from will be default 1, but range inbetween 1 and numPages
      // to will be default numPages, but range inbetween 1 and numPages
      const from = Math.min(Math.max(context.props.pageFrom ? context.props.pageFrom : 1, 1), numPages)
      const to = Math.min(Math.max(context.props.pageTo ? context.props.pageTo : numPages, 1), numPages)
      // loop through 1 to numPages
      for (let i = from; i <= to; i++) {
        pages.push(createPage(i))
      }
      if (pages.length === 0) {
        // don't return empty, otherwise we will not be able to access the propEditor etc to correct the wrong settings
        // default will be page 1
        return createPage(1)
      } else {
        return pages
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pdf {
  position: relative;
  overflow: hidden;

  .content {
    width: 100%;
    height: auto;
    pointer-events: none;
  }
}

.pdf.fullscreen {
  .content {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
